import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Container, Grid, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import NotFoundImage from 'assets/images/not-found.png';
import Page from './Page';

const NotFoundContainer = styled(Container)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  paddingTop: '70px',
  minHeight: '100vh',

  [theme.breakpoints.down('md')]: {
    paddingTop: 0,
    minHeight: 0,
  },
}));

const NotFoundTitle = styled(Typography)(() => ({
  color: '#323232',
  textAlign: 'center',
  marginBottom: '12px',
}));

const NotFoundCard = styled(Grid)(({ theme }) => ({
  maxWidth: '700px',
  margin: '20px 0',
  padding: '58px 158px',
  borderRadius: '0.25rem',
  border: '1px solid rgba(112, 112, 112, 0.16)',

  [theme.breakpoints.down('sm')]: {
    maxWidth: '600px',
    padding: '32px 38px',
  },
}));

const Image = styled('img')(() => ({ width: '100%' }));

const GlobalNotFound = () => {
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      navigate('/');
    }, 3500);
  }, [navigate]);

  return (
    <Page title="Not Found">
      <NotFoundContainer>
        <Grid container flexDirection="column" alignItems="center">
          <NotFoundCard
            item
            container
            flexDirection="column"
            alignItems="center"
          >
            <Grid item>
              <NotFoundTitle
                typography={{ xs: 'xSubheading18', md: 'xSubheading24' }}
              >
                The page you seek is missing! Don&apos;t worry, you can still
                visit other pages.
              </NotFoundTitle>
            </Grid>
            <Grid item>
              <Image src={NotFoundImage} alt="not-found" />
            </Grid>
          </NotFoundCard>
        </Grid>
      </NotFoundContainer>
    </Page>
  );
};

export default GlobalNotFound;
